/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Spinner, Modal,
    ModalBody, ModalFooter } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead,
    PaginationComponent,
} from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel, useDownloadExcel } from 'react-export-table-to-excel';
import OptionS from "../../../components/DynmicOption/OptionS";
import OptionC from "../../../components/DynmicOption/OptionC";
import OptionM from "../../../components/DynmicOption/OptionM";
import ES4ReportEmployment from "./ES4ReportEmployment";
import loadspinner from "../../../../assets/images/spinner.gif"

const ES4DataReport = ({ ...props }) => {
    const [itemPerPage, setItemPerPage] = useState(1500);
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);
    const [lorder, setLorder] = useState(true);
    const [loadmain, setloadmain] = useState(true);
    const [load, setload] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [modal, setmodal] = useState(false);
    const [id, setid] = useState(0);
    const [nextloading, setnextloading] = useState(false);
    const [DataCount, setDataCount] = useState(0);
    const today = new Date();
    const tableRef = useRef(null);
    const table1Ref = useRef(null);
    const [generate1, setgenerate1] = useState(true);
    const [loading, setloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 4,
        state: -1
    });
    const { onDownload } = useDownloadExcel({
        filename:"ES4 Report",
        sheet:"users",
        currentTableRef:tableRef.current
    })
    const [states, setstates] = useState("")
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
        setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });
   
    };
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };

    const paginate = (pageNumber) => {
        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow");
        mainid.scrollIntoView();
        //console.log(mainid);
        
        setCurrentPage(pageNumber)

        if (formData.state !== "0") { getdata3(pageNumber) } else { getdataAll(pageNumber) }



    };
    const getdata3 = async (pageno) => {
        const sendData = {

            EmploymentRefId: Number(4),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(1500),
            Skip: Number((pageno - 1) * 1500)
        }
        
        // Validate UserId before sending request
        if (sendData.UserId < 1) {
            console.error('Invalid UserId:', sendData.UserId);
            setStatee([]);
            setload(true);
            setmodal(false);
            setnextloading(false);
            alert("Please select a state.");
            return;
        }

        console.log('Sending request with data:', sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES4MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log(data)
                   // setStatee([])
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                })


    };

    const getdatacount = async () => {
        const sendData = {

            EmploymentRefId: Number(4),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES4MISCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdatacountAll = async () => {
        const sendData = {

            EmploymentRefId: Number(4),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES4MISCOUNTALL', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdataAll = async (page) => {
        const sendData = {
            EmploymentRefId: Number(4),
            UserId: Number(0),
            StateId: formData.state === "0" ? null : Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(1500),
            Skip: Number((page - 1) * 1500)
        }
       // console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES4MISAll', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // console.log(data)
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)


                })


    };


    const generate = async () => {
        // Validate that a valid user has been selected
        if (formData.state === -1) {
            alert("Please select a state");
            return;
        }

        sessionStorage.setItem("NumberES4", 0)
        setloadmain(false)
        getdatacount()
        getdata3(1)
        setgenerate1(false)
        setmodal(true)
    }

    const generateAll = async () => {
        sessionStorage.setItem("NumberES4", 0)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)
    }

    useEffect(() => {


        if (modal) {
            // console.log("Start")
            const iimain = setTimeout(() => {
                setmodal(false)

            }, 500000);

            setid(iimain);

        }
        else {
            //console.log("Closed", id)
            window.clearTimeout(id);
            setid(0);
        }

    }, [modal])

   /* const Check = () => {
        for (var i = 1; i < 5; i++) {
            paginate(i,true)
       
        console.log("Hello",i)
        }
    }*/


    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <BlockHead size="lg">

                            <BlockDes className="text-soft">
                        <Row >

                            <Col xl="3" md="3">
                                <td >
                                    <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                </td>
                            </Col>
                            <Col xl="3" md="3" >

                                <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}><OptionS catid="43" onInputChange={onInputChange} namemain="state" mainid="state" /></label></label>
                                    </Col>
                                    <Col xl="3" md="3" >

                                        <label style={{ color: 'black', fontSize: 15 }}>From: <label style={{ fontWeight: 'bold' }}><OptionC onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>
                                    </Col>
                                     <Col xl="3" md="3" >

                                        <label style={{ color: 'black', fontSize: 15 }}> To: <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange3} year={formData.year} month={formData.month} /></label></label>
                            </Col>
                                    <Col xl="3" md="3" >
                                        {formData.state !== String(0) ? <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button> :
                                            <Button color="success" style={{ marginTop: 10 }} onClick={() => generateAll()}>Generate</Button>}


                                    </Col>
                                </Row>
                            </BlockDes>


                        </BlockHead>
                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>

                                <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>
                                <hr />
                        {generate1 ? <h3>Please Select State and Month to Generate Report!!</h3> :
                            <>
                                {modal ? <div>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner size="xl" />
                                    </div>
                                </div> : null}
                                <div style={{ visibility: modal ? "hidden" : "visible" }}>
                                <h3 style={{ marginBottom: 40 }}>Employment Report (ES4)
                                    {loadmain ?
                                        <Button disabled style={{ float: "right" }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                            : 

                                            <Button onClick={onDownload} ref={table1Ref} style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                       } </h3>



                                <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>

                                    <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                        <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                            <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                    <tr>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Form: ES4 Report

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            State: {states}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            From Date: {month1[formData.month]} {formData.year}

                                                        </th>
                                                        <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                           To Date: {month1[formData.tomonth]} {formData.toyear}

                                                        </th>
                                                    </tr>
                                                </thead>
                                            </div>
                                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                <tr >

                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                        S. No.

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 80 }} >
                                                        Year

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 80 }} >
                                                        Month

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 100 }} >
                                                        State

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                        Employment Exchange

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                        NCO Code 2015 ( 8 digit level )

                                                    </th>
                                                    <th rowSpan="2" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                        Trade in which trained

                                                    </th>
                                                    <th colSpan="3" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                        Ex-ITI Trainees
                                                    </th>

                                                    <th colSpan="3" style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                        Full term Apprentices

                                                    </th>
                                                </tr>
                                                <tr>

                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                    <td style={{ textAlign: 'center', border: '2px solid black', color: "black", backgroundColor: 'orange', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                </tr>










                                            </thead>

                                            <tbody class="css-serial" className="css-serial">
                                                    <td id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></td>
                                                    {nextloading ? <div>
                                                        <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <Spinner size="xl" />
                                                        </div>
                                                    </div> : load ? (Statee.length !== 0 && nextloading === false ? Statee.map((details, index) =>
                                                        <tr key={index}>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>{(itemPerPage * (currentPage - 1)) + index + 1}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.yearId}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {month1[details.monthId]}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.statename}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                <b>  {details.center}</b>
                                                            </td>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                {details.ncoCode20158DigitLevel2 === null ? 0 : details.ncoCode20158DigitLevel2}
                                                            </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.tradeInWhichTrained3 === null ? 0 : details.tradeInWhichTrained3}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.registration4 === null ? 0 : details.registration4}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.placement5 === null ? 0 : details.placement5}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.liveRegister6 === null ? 0 : details.liveRegister6}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.registration7 === null ? 0 : details.registration7}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.placement8 === null ? 0 : details.placement8}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} > {details.liveRegister9 === null ? 0 : details.liveRegister9}</td>
                                                            

                                                        </tr>
                                                   

                                                ):<h3>No Data Found</h3>) : <Spinner color="success" />}



                                            </tbody>
                                        </table>

                                    </div>



                                    </div>
                                </div>
                                {Statee.length > 0 && (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={DataCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        EmploymentRefId={3}
                                        UserId={formData.state}
                                        MonthId={formData.month}
                                        YearId={formData.year}
                                        ToYearId={formData.toyear}
                                        ToMonthId={formData.tomonth}
                                        setStatee={setStatee}
                                        setmodal={setmodal}
                                        setload={setload}
                                    />
                                )}
                            </>}



                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES4DataReport;
